/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import PropTypes from 'prop-types';

const HeaderSearchLink = ({ handleRoute, currentSearchTerm }) => (
  <a
    className="search-modal-link"
    onClick={() =>
      handleRoute({
        pathname: '/search',
        query: {
          search_term: currentSearchTerm
        }
      })
    }>
    Show all results for &quot;{currentSearchTerm.toUpperCase()}&quot;
  </a>
);

HeaderSearchLink.propTypes = {
  handleRoute: PropTypes.func.isRequired,
  currentSearchTerm: PropTypes.string.isRequired
};

export default HeaderSearchLink;
